var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"min-h-screen"},[_c('Toast'),(_setup.isUserLoaded)?_c('RouterView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }